<template>
  <topHeader />
  <div class="zixunDetail">
    <div class="container">
      <!-- 面包屑导航 -->
      <div class="breadcrumb">
        <!-- <span class="breadcrumb-text">所在位置:</span>
        <a href="#" class="breadcrumb-link">秦土平台</a>
        <span class="breadcrumb-separator">></span> -->
        <a @click="switchPage('news')" class="breadcrumb-link">水保资讯</a>
        <span class="breadcrumb-separator">></span>
        <span class="breadcrumb-current">资讯详情</span>
      </div>

      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <div class="loading-text">加载中...</div>
      </div>

      <!-- 内容区域 -->
      <template v-else>
        <!-- 文章标题 -->
        <div class="article-title">
          <h1>{{ currentNews.title }}</h1>
        </div>

        <!-- 文章元数据 -->
        <div class="article-meta">
          <span class="meta-date" v-if="currentNews.date">{{ currentNews.date }}</span>
          <span class="meta-separator" v-if="currentNews.source">来源:</span>
          <span class="meta-source" v-if="currentNews.source">{{ currentNews.source }}</span>
          <span class="meta-separator" v-if="currentNews.viewCount !== undefined">浏览：{{ currentNews.viewCount }}</span>
        </div>

      <!-- 导读区域
      <div class="article-intro">
   
        <div class="intro-content">
            【导读】 {{ currentNews.intro }}
        </div>
      </div> -->

    

        <!-- 附件预览 -->
        <div v-if="currentNews.attachment" class="article-attachment">
          <a @click.prevent="previewAttachment" class="attachment-link" href="javascript:void(0)">
            <span class="iconfont icon-yulan"></span>
            附件：{{ currentNews.attachmentName || getFileName(currentNews.attachment) }}
          </a>
        </div>

        <!-- 文章正文 -->
        <div class="article-content">
          <div class="content-section" v-html="formatContent(currentNews.content)"></div>
        </div>

        <!-- 底部导航 -->
        <div class="article-footer">
          <div class="footer-nav">
            <a 
              v-if="prevNews" 
              @click="goToNews(prevNews.id)" 
              class="nav-link prev-link"
            >
              上一篇: {{ prevNews.title }}
            </a>
            <span v-else class="nav-link prev-link disabled">上一篇: -</span>
            <a 
              v-if="nextNews" 
              @click="goToNews(nextNews.id)" 
              class="nav-link next-link"
            >
              下一篇: {{ nextNews.title }}
            </a>
            <span v-else class="nav-link next-link disabled">下一篇: -</span>
          </div>
        </div>
      </template>
    </div>

    <!-- PDF预览弹窗 -->
    <div v-if="showPdfPreview" class="pdf-preview-modal" @click.self="closePdfPreview">
      <div class="pdf-preview-container">
        <div class="pdf-preview-header">
          <h3>{{ currentNews.attachmentName || getFileName(currentNews.attachment) }}</h3>
          <button class="close-btn" @click="closePdfPreview">×</button>
        </div>
        <div class="pdf-preview-content">
          <iframe 
            :src="pdfPreviewUrl" 
            class="pdf-iframe"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
import TopHeader from './top-Header.vue'
import Footer from './Footer.vue'
import { getConsultInfoDetail, getConsultInfoList } from '@/api'

export default {
  name: 'zixunDetail',
  components: {
    TopHeader,
    Footer
  },
  data() {
    return {
      currentNews: {
        id: null,
        title: '',
        content: '',
        source: '',
        publishTime: '',
        createTime: '',
        viewCount: 0,
        attachment: null,
        attachmentName: null
      },
      loading: false,
      prevNews: null,
      nextNews: null,
      showPdfPreview: false,
      pdfPreviewUrl: ''
    }
  },
  computed: {
    attachmentUrl() {
      if (!this.currentNews.attachment) return ''
      const baseUrl = 'https://qtzp.qhdbigdata.com/qtzp-api/upload/'
      // 如果attachment已经是完整URL，直接返回，否则拼接
      return this.currentNews.attachment.startsWith('http') 
        ? this.currentNews.attachment 
        : baseUrl + this.currentNews.attachment
    }
  },
  mounted() {
    this.loadNewsDetail();
    this.loadPrevNext();
  },
  methods: {
    switchPage() {
      // 点击首页时跳转到根路径，显示QintuPlatform组件
      this.$router.push('/zixunlist');
    },
    
    // 加载上一篇和下一篇
    async loadPrevNext() {
      const id = this.$route.query.id || this.$route.params.id
      if (!id) return
      
      try {
        // 获取列表数据，用于查找上一篇和下一篇
        const params = {
          type: '0', // 0水保咨询
          pageNum: '1',
          pageSize: '1000' // 获取足够多的数据
        }
        
        const res = await getConsultInfoList(params)
        const list = (res && res.rows) || res?.data?.rows || res?.data || []
        
        // 找到当前项在列表中的位置
        const currentIndex = list.findIndex(item => String(item.id) === String(id))
        
        if (currentIndex !== -1) {
          // 设置上一篇
          if (currentIndex > 0) {
            const prevItem = list[currentIndex - 1]
            this.prevNews = {
              id: prevItem.id,
              title: prevItem.title || prevItem.name || '未命名'
            }
          } else {
            this.prevNews = null
          }
          
          // 设置下一篇
          if (currentIndex < list.length - 1) {
            const nextItem = list[currentIndex + 1]
            this.nextNews = {
              id: nextItem.id,
              title: nextItem.title || nextItem.name || '未命名'
            }
          } else {
            this.nextNews = null
          }
        }
      } catch (error) {
        console.error('获取上一篇/下一篇失败:', error)
        this.prevNews = null
        this.nextNews = null
      }
    },
    
    async loadNewsDetail() {
      // 从路由query参数获取id
      const id = this.$route.query.id || this.$route.params.id
      
      if (!id) {
        console.error('缺少id参数')
        this.$router.push('/zixunlist')
        return
      }
      
      this.loading = true
      try {
        const res = await getConsultInfoDetail(id)
        
        // 处理返回数据
        const data = res?.data || res || {}
        
        this.currentNews = {
          id: data.id || id,
          title: data.title || '未命名',
          content: data.content || data.detail || '',
          source: data.source || '',
          publishTime: data.publishTime || data.createTime || '',
          createTime: data.createTime || '',
          viewCount: data.viewCount || 0,
          attachment: data.attachment || null,
          attachmentName: data.attachmentName || null
        }
        
        // 格式化日期
        if (this.currentNews.publishTime) {
          this.currentNews.date = this.formatDate(this.currentNews.publishTime)
        } else if (this.currentNews.createTime) {
          this.currentNews.date = this.formatDate(this.currentNews.createTime)
        } else {
          this.currentNews.date = ''
        }
      } catch (error) {
        console.error('获取资讯详情失败:', error)
        // 清空数据
        this.currentNews = {
          id: null,
          title: '',
          content: '',
          source: '',
          publishTime: '',
          createTime: '',
          viewCount: 0,
          attachment: null,
          attachmentName: null
        }
        // 显示错误提示
        alert('获取资讯详情失败，请稍后重试')
        // 跳转回列表页
        setTimeout(() => {
          this.$router.push('/zixunlist')
        }, 2000)
      } finally {
        this.loading = false
      }
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },
    
    // 格式化内容（处理HTML和换行）
    formatContent(content) {
      if (!content) return ''
      // 如果内容包含HTML标签，直接返回
      if (content.includes('<') && content.includes('>')) {
        return content
      }
      // 否则将换行符转换为<br>
      return content.replace(/\n/g, '<br>')
    },
    
    // 跳转到其他资讯
    goToNews(id) {
      if (id) {
        this.$router.push({
          path: '/zixunDetail',
          query: { id }
        }).then(() => {
          // 重新加载数据
          this.loadNewsDetail()
          this.loadPrevNext()
          // 滚动到顶部
          window.scrollTo({ top: 0, behavior: 'smooth' })
        })
      }
    },
    
    // 预览附件
    previewAttachment() {
      if (!this.currentNews.attachment) return
      this.pdfPreviewUrl = this.attachmentUrl
      this.showPdfPreview = true
    },
    
    // 关闭PDF预览
    closePdfPreview() {
      this.showPdfPreview = false
      this.pdfPreviewUrl = ''
    },
    
    // 从文件路径提取文件名
    getFileName(filePath) {
      if (!filePath) return '附件'
      // 如果是完整URL，提取路径部分
      let path = filePath
      try {
        const url = new URL(filePath)
        path = url.pathname
      } catch (e) {
        // 如果不是URL，直接使用
      }
      // 提取文件名
      const fileName = path.split('/').pop() || path.split('\\').pop() || '附件'
      return fileName
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background: #f5f5f5;

}

/* 面包屑导航 */
.breadcrumb {
  margin-bottom: 20px;
  font-size: 14px;
  color: #666;
  text-align: left;
}

.breadcrumb-text {
  color: #999;
}

.breadcrumb-link {
  color: #422C27;
  text-decoration: none;
  margin: 0 5px;
}

.breadcrumb-link:hover {
  text-decoration: underline;
}

.breadcrumb-separator {
  margin: 0 5px;
  color: #999;
}

.breadcrumb-current {
  color: #333;
  margin-left: 5px;
}

/* 文章标题 */
.article-title {
  text-align: center;
  margin-bottom: 20px;
}

.article-title h1 {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin: 0;
  line-height: 1.4;
}

/* 文章元数据 */
.article-meta {
  text-align: center;
  margin-bottom: 30px;
  font-size: 14px;
  color: #666;
}

.meta-date {
  color: #999;
}

.meta-separator {
  margin: 0 5px;
  color: #999;
}

.meta-source,
.meta-author {
  color: #999;
}

/* 导读区域 */
.article-intro {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
}

.intro-label {
  font-weight: bold;
  color: #422C27;
  margin-bottom: 10px;
  font-size: 16px;
}

.intro-content {
  line-height: 1.6;
  color: #666;
  font-size: 15px;
}

/* 广告位 */
.ad-placeholder {
  height: 200px;
  background: #f0f0f0;
  border: 2px dashed #ccc;
  border-radius: 8px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
}

/* 文章正文 */
.article-content {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-bottom: 30px;
}

.content-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin: 0 0 30px 0;
  text-align: center;
}

.content-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #422C27;
}

.requirement-list,
.condition-list {
  margin: 15px 0;
  padding-left: 20px;
}

.requirement-list li,
.condition-list li {
  margin-bottom: 10px;
  line-height: 1.6;
  color: #666;
}

.note-text {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 10px;
  margin-top: 15px;
  font-size: 14px;
  color: #856404;
}

/* 底部导航 */
.article-footer {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.footer-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-link {
  color: #422C27;
  text-decoration: none;
  font-size: 14px;
  padding: 8px 15px;
  border: 1px solid #422C27;
  border-radius: 4px;
  transition: all 0.3s;
}

.nav-link:hover {
  background: #422C27;
  color: white;
}

.prev-link {
  margin-right: auto;
}

.next-link {
  margin-left: auto;
}

/* 加载状态 */
.loading-container {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.loading-text {
  font-size: 16px;
  color: #666;
}

/* 附件下载 */
.article-attachment {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 15px 20px;
  margin-bottom: 30px;
}

.attachment-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #422C27;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
}

.attachment-link:hover {
  color: #E4CEC2;
  text-decoration: underline;
}

.nav-link.disabled {
  color: #999;
  cursor: not-allowed;
  border-color: #ddd;
}

.nav-link.disabled:hover {
  background: transparent;
  color: #999;
}

.article-content {
  text-align: left;
}

/* PDF预览弹窗 */
.pdf-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.pdf-preview-container {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 1200px;
  height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.pdf-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
  flex-shrink: 0;
}

.pdf-preview-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
  font-weight: 500;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pdf-preview-header .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.3s;
  flex-shrink: 0;
  margin-left: 15px;
}

.pdf-preview-header .close-btn:hover {
  background: #eee;
}

.pdf-preview-content {
  flex: 1;
  overflow: hidden;
  position: relative;
}

.pdf-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

@media (max-width: 768px) {
  .pdf-preview-container {
    width: 95%;
    height: 95vh;
  }
  
  .pdf-preview-header {
    padding: 12px 15px;
  }
  
  .pdf-preview-header h3 {
    font-size: 14px;
  }
}
</style>